export class Office {
    OfficeId: string = '';
    OfficeDescription: string = '';
    ProgramSponsorId: string = '';
    OfficeActive: boolean;
    CreatedBy: string = '';
    ModifiedBy: string = '';
    ModifiedDate: Date;
    CreatedDate: Date;
}